// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"6628ca59","285":"8e011098","952":"32f274bb"}[chunkId] + ".chunk.js";
};